module.exports = __webpack_public_path__ + "media/Audio19_j.6c282788.wav";